import React from 'react';
import { createSvgIcon } from '@material-ui/core/utils';

// TODO(cleanup): eliminar este archivo y usar el ícono oficial en cuanto se
// actualice @material-ui/icons a una versión que lo incluya (ver nota abajo).
//
// @material-ui/icons en la versión instalada (4.11.3) no incluye el ícono
// "Auto Awesome" (las 3 estrellitas usadas típicamente para indicar
// contenido/resultados generados por IA), ya que se agregó al set de
// Material Design después de esa versión. Se define localmente con el mismo
// path oficial y el mismo helper (createSvgIcon) que usa @material-ui/icons
// internamente, para que se vea y comporte igual que cualquier otro ícono
// de Material-UI (soporta las mismas props: fontSize, color, className, etc.).
//
// Al actualizar @material-ui/icons, verificar si ya expone
// '@material-ui/icons/AutoAwesome'; si existe, reemplazar los usos de este
// componente por ese import y borrar este archivo.
const AutoAwesomeIcon = createSvgIcon(
  <path d="M19 9l1.25-2.75L23 5l-2.75-1.25L19 1l-1.25 2.75L15 5l2.75 1.25L19 9zm-7.5.5L9 4 6.5 9.5 1 12l5.5 2.5L9 20l2.5-5.5L17 12l-5.5-2.5zM19 15l-1.25 2.75L15 19l2.75 1.25L19 23l1.25-2.75L23 19l-2.75-1.25L19 15z" />,
  'AutoAwesome',
);

export default AutoAwesomeIcon;
